<template>
  <div id="lm-upload-files">
    <label
      :for="id"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>

    <vue-dropzone
      ref="myVueDropzone"
      :class="{'is-invalid': v.$error}"
      :id="id"
      :options="dropzoneOptions"
      v-on:vdropzone-removed-file="fileRemoved"
      v-on:vdropzone-success="fileCreated"
      v-on:vdropzone-error="errorHappend"
      v-on:vdropzone-file-added="fileAdded"
      ></vue-dropzone>
      <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>

  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import lmInputMixin from '@/mixins/lmInputMixin.js'
/**
* LmUploadFiles es un wrapper de vue-dropzone
*
* https://github.com/rowanwins/vue-dropzone GitHub
*
* https://rowanwins.github.io/vue-dropzone/docs/dist/index.html#/props Page
*
*/
export default {
  mixins: [lmInputMixin],
  components: {
    vueDropzone
  },
  data () {
    return {
      preloadImg: false
    }
  },
  props: {
    /**
    * Setea options https://rowanwins.github.io/vue-dropzone/docs/dist/index.html#/props
    */
    dropzoneOptions: {
      type: Object,
      default: () => ({
        url: 'https://httpbin.org/post'
      }),
      required: true
    },
    /**
    * Setea id https://rowanwins.github.io/vue-dropzone/docs/dist/index.html#/props
    */
    id: {
      type: String,
      default: 'dropzone'
    },
    dictDefaultMessage: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  created () {
    // XXX no pude hacer que funcione llamar a this.$t desde props
    this.dropzoneOptions.dictDefaultMessage = this.dictDefaultMessage || this.$t('drop_files_here_to_upload')
    this.dropzoneOptions.dictRemoveFile = this.$t('remove_file')
  },
  methods: {
    fileAdded (file, error, xhr) {
      this.$emit('vdropzone-file-added', file, error, xhr)
    },
    fileRemoved (file, error, xhr) {
      this.$emit('vdropzone-removed-file', file, error, xhr)
    },
    fileCreated (file, response) {
      this.$emit('vdropzone-success', file, response)
    },
    errorHappend (file, message, xhr) {
      this.$emit('vdropzone-error', file, message, xhr)
    },
    lmManuallyAddFile (fileOptions, url) {
      this.$refs.myVueDropzone.manuallyAddFile(fileOptions, url)
    },
    lmRemoveAllFiles () {
      this.$refs.myVueDropzone.removeAllFiles()
    },
    lmRemoveFile (file) {
      this.$refs.myVueDropzone.removeFile(file)
    },
    disable (fileOptions, url) {
      this.$refs.myVueDropzone.disable()
    },
    enable (fileOptions, url) {
      this.$refs.myVueDropzone.enable()
    }
  }
}
</script>

<style lang="sass" scoped>
.is-invalid
  border: 1px solid #dc3545
  border-radius: 0.25rem
</style>
